import { render, staticRenderFns } from "./Delivery.vue?vue&type=template&id=c9f8b506&lang=pug&"
import script from "./Delivery.vue?vue&type=script&lang=ts&"
export * from "./Delivery.vue?vue&type=script&lang=ts&"
import style0 from "./Delivery.vue?vue&type=style&index=0&id=c9f8b506&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports